import { union, geodesicArea, planarArea } from '@arcgis/core/geometry/geometryEngine'
import { project } from '@arcgis/core/geometry/projection'
import { postDraftSiteGeometry } from 'api/site'
import { AREA_DECIMAL_PLACES, COORDINATES_DECIMAL_PLACES } from 'constants/map'


// Retrieve attributes like area and centroid from geometry
const getFeatureAttributesFromGeometry = (newGeometry) => {
    // fixes "not implemented" error
    const areaFn = (newGeometry.spatialReference.isWGS84 || newGeometry.spatialReference.isWebMercator) ? geodesicArea : planarArea
    // depending on backend config, the geometry might not be in webmercator, so might not have lat/long:
    const geometryWithLatLong = (newGeometry.spatialReference.isWGS84 || newGeometry.spatialReference.isWebMercator) ? newGeometry : project(newGeometry, { wkid: 3857 })
    return {
        sitarea: areaFn(newGeometry, 'square-kilometers')?.toFixed(AREA_DECIMAL_PLACES),
        // https://developers.arcgis.com/javascript/latest/api-reference/esri-geometry-Polygon.html#centroid
        // the following is the centroid of the largest part of a multipart polygon
        sitlat: geometryWithLatLong?.centroid?.latitude?.toFixed(COORDINATES_DECIMAL_PLACES),
        sitlong: geometryWithLatLong?.centroid?.longitude?.toFixed(COORDINATES_DECIMAL_PLACES)
    }
}


/**
 * Adds graphics to the KBA layer and processes boundary complexity.
 *
 * @param {Array} graphics - An array of Graphic objects representing geometries to add to the KBA layer.
 * @param {Object} params - Parameters needed for the API call, including site ID and siteHistoryId.
 */

// Main function to add graphics to KBA layer
const addGraphicsToKBALayer = async(graphics, params) => {
    const geometries = graphics.map((graphic) => graphic.geometry)
    const unifiedGeometry = union(geometries)

    const attributes = getFeatureAttributesFromGeometry(unifiedGeometry)
    await postDraftSiteGeometry(params.id, params.siteHistoryId, unifiedGeometry, attributes)
}

export default addGraphicsToKBALayer
